<div
	*ngIf="{
    tab: (this.selectedTab.value$ | async),
    mode: (this.selectedDisplayMode$ | async),
  } as view"
	class="flex flex-col"
	id="wrapper"
>
	<tg-toolbar
		hideTeams
		showFrill
		tbclass="mat-toolbar-tg mat-toolbar-base --timer-rc-header mat-elevation-z0"
	></tg-toolbar>
	<div
		[ngClass]="{ 'h-16': view.tab === 'work' }"
		*ngIf=" !(this.isMobile$ | async)"
		class="record-toolbar-card mat-bg-card relative z-10 shadow-lg"
	>
		<ng-container *ngTemplateOutlet="view.tab === 'work' ? comegoToolbar : projectToolbar"></ng-container>
		<ng-template #projectToolbar>
			<div class="container">
				<app-record-toolbar
					[isLoading]="this.recordLoading$ | async"
					#recordToolbar
				></app-record-toolbar>
			</div>
		</ng-template>
		<!-- not my idea -->
		<ng-template #comegoToolbar>
			<ng-container *ngIf="comegoEnabled$ | async">
				<div class="container mx-auto flex h-16 items-center"><tg-come-and-go-box></tg-come-and-go-box></div>
			</ng-container>
		</ng-template>
	</div>
	<ng-container
		*ngTemplateOutlet="view.mode === 'Calendar' ? calendarHost : view.mode === 'ComeGo' ? comegoHost : defaultHost"
	></ng-container>
	<ng-template #comegoHost>
		<div class="timer-content-wrapper">
			<div class="timer-content">
				<div class="container">
					<div class="time-entries-wrapper mt-1 flex flex-col pb-[256px]">
						<ng-container *ngTemplateOutlet="tableHead"></ng-container>
						<tg-time-comego-view></tg-time-comego-view>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template #defaultHost>
		<div class="timer-content-wrapper">
			<div class="timer-content">
				<div class="container">
					<div class="time-entries-wrapper mt-1 flex flex-col pb-[256px]">
						<ng-container *ngTemplateOutlet="tableHead"></ng-container>
						<app-time-tracker-table
							[byDayTreshold]="this.byDayTreshold$ | async"
							[emptyTemplate]="noTableItems"
							[range]="rangeValue$ | async"
							[showCompleted]="this.showCompleted"
						></app-time-tracker-table>
						<div
							*ngIf="this.isLoading$ | async"
							class="my-3"
						>
							<ng-container *ngTemplateOutlet="loadingCards"></ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</div>
<ng-template #calendarHost>
	<div class="container">
		<div class="mt-2 flex flex-row items-center justify-start gap-2 text-left">
			<div class="wflex-[1_1_12px] xl:flex-auto"></div>
			<div class="justify-content-stretch flex flex-shrink-0 space-x-3 xl:justify-start">
				@if((selectedDisplayMode$ | async) === 'ComeGo' && (scheduleEnabled$ | async)) {
				<ng-container>
					<ng-container *rxIf="times$schedule; let sched">
						<ng-container
							*ngTemplateOutlet="
								scheduleWeekView;
								context: {
								$implicit: sched,
								isProjectTab: false,
								}
							"
						></ng-container>
					</ng-container>
				</ng-container>
				} @else if(workinhoursEnabled$.value$ | async ) {
				<div
					*ngIf="sumOfWeek$ | async as item"
					class="mat-bd-5 mat-typography grid h-12 items-center gap-x-6 rounded-lg px-4"
				>
					<div class="flex flex-col text-right text-sm">
						<span [matTooltip]=" 'time.plural'| translate ">
							{{ item?.total ?? 0 | parseMsAsDuration: false }}
							h
						</span>
						<span
							[matTooltip]=" 'Billable'| translate "
							class="mat-text-accent"
						>
							{{ (item.billable ? item.billable : 0) | parseMsAsDuration: false }}
							h
						</span>
					</div>
				</div>
				} @else {
				<ng-container>
					<ng-container *rxIf="times$schedule; let sched">
						<ng-container
							*ngTemplateOutlet="
								scheduleWeekView;
								context: {
								$implicit: sched,
								isProjectTab: false,
								}
							"
						></ng-container>
					</ng-container>
				</ng-container>
				}
				<ng-container *ngTemplateOutlet="viewToggleRow"></ng-container>
			</div>
		</div>
	</div>
	<app-time-tracker-calendar class="container"></app-time-tracker-calendar>
</ng-template>
<ng-template #noTableItems>
	<div class="flex h-32 items-center justify-center">{{ 'utils.noitems-time' | translate }}</div>
</ng-template>
<ng-template #tableHead>
	<div
		class="mb-3 mt-2 flex items-center text-left"
		ngClass.lt-xl="justify-center"
	>
		<shell-menu-toggle [teamsOnly]="true"></shell-menu-toggle>
		<div class="flex flex-col items-center xl:items-start xl:flex-auto xl:flex-row">
			<div
				*ngIf="viewDate$status | async as vd"
				class="flex space-x-1"
			>
				<button
					(click)="prev()"
					[disabled]="(this.isLoading$ | async) || (!vd.isFuture && !vd.isValidRange)"
					[matTooltip]="'utils.older' | translate"
					class="mat-button-square !rounded-lg"
					fxHide.lt-sm
					mat-button
				>
					<mat-icon>chevron_left</mat-icon>
				</button>
				<button
					(click)="dayPickerPopover.toggle()"
					[disabled]="this.isLoading$ | async"
					[matTooltip]="'utils.pickTimeRange' | translate"
					[satPopoverAnchor]="dayPickerPopover"
					class="mt-1 h-10 flex items-center justify-start gap-1"
					mat-button
				>
					<ng-container *ngIf="vd.sameDay; else vdRange">
						<span>{{ vd.start | formatDate: 'iiii' }}</span>
						<span>{{ vd.start | formatDate: 'PP' }}</span>
						<span>({{ 'timer.calendar.kw' | translate: { value: vd.start | formatDate: 'I' } }})</span>
					</ng-container>
					<ng-template #vdRange>
						<span>{{ vd.start | formatDate: 'PP' }}</span>
						<span>-</span>
						<span>{{ vd.end | formatDate: 'PP' }}</span>
						<span>({{ 'timer.calendar.kw' | translate: { value: vd.start | formatDate: 'I' } }})</span>
					</ng-template>
				</button>
				<button
					(click)="next()"
					[disabled]="(this.isLoading$ | async) || (vd.isFuture && !vd.isValidRange)"
					[matTooltip]="'utils.newer' | translate"
					class="mat-button-square !rounded-lg"
					fxHide.lt-sm
					mat-button
				>
					<mat-icon>chevron_right</mat-icon>
				</button>
				<button
					(click)="today()"
					[disabled]="(this.isLoading$ | async) || vd.sameWeek"
					[matTooltip]="'timer.calendar.today' | translate"
					fxHide.lt-sm
					mat-icon-button
				>
					<mat-icon>today</mat-icon>
				</button>
			</div>
			<div class="wflex-[1_1_12px] xl:flex-auto"></div>
			<div class="justify-content-stretch flex flex-shrink-0 space-x-3 xl:justify-start">
				@if((selectedDisplayMode$ | async) === 'ComeGo' && (scheduleEnabled$ | async)) {
				<ng-container>
					<ng-container *rxIf="times$schedule; let sched">
						<ng-container
							*ngTemplateOutlet="
								scheduleWeekView;
								context: {
								$implicit: sched,
								isProjectTab: false,
								}
							"
						></ng-container>
					</ng-container>
				</ng-container>
				} @else if(workinhoursEnabled$.value$ | async ) {
				<div
					*ngIf="sumOfWeek$ | async as item"
					class="mat-bd-5 mat-typography grid h-12 items-center gap-x-6 rounded-lg px-4"
				>
					<div class="flex flex-col text-right text-sm">
						<span [matTooltip]=" 'time.plural'| translate ">
							{{ item?.total ?? 0 | parseMsAsDuration: false }}
							h
						</span>
						<span
							[matTooltip]=" 'Billable'| translate "
							class="mat-text-accent"
						>
							{{ (item.billable ? item.billable : 0) | parseMsAsDuration: false }}
							h
						</span>
					</div>
				</div>
				} @else {
				<ng-container>
					<ng-container *rxIf="times$schedule; let sched">
						<ng-container
							*ngTemplateOutlet="
								scheduleWeekView;
								context: {
								$implicit: sched,
								isProjectTab: false,
								}
							"
						></ng-container>
					</ng-container>
				</ng-container>
				}
				<ng-container *ngTemplateOutlet="viewToggleRow"></ng-container>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #loadingCards>
	<div class="flex flex-col gap-[15px]">
		<mat-card *ngFor="let __d of [0, 0, 0, 0, 0]; let i = index">
			<mat-card-title-group class="group-header flex flex-row items-start justify-start">
				<mat-card-title class="group-date">
					<div class="flex flex-col gap-1">
						<div style="height: 20px; width: 80px">
							<div class="mat-skeleton"></div>
						</div>
						<div style="height: 20px; width: 60px">
							<div class="mat-skeleton"></div>
						</div>
					</div>
				</mat-card-title>
				<div class="flex-auto"></div>
				<div class="flex flex-row items-center justify-start gap-3">
					<div class="flex flex-col gap-1">
						<div style="height: 20px; width: 80px">
							<div class="mat-skeleton"></div>
						</div>
						<div style="height: 20px; width: 80px">
							<div class="mat-skeleton"></div>
						</div>
					</div>
				</div>
			</mat-card-title-group>
			<mat-card-content>
				<div
					class="mat-skeleton"
					style="height: 20px"
				></div>
			</mat-card-content>
		</mat-card>
	</div>
</ng-template>
<ng-template #viewToggleRow>
	<ng-template #viewToggleContent>
		<ng-container *ngIf="selectedDisplayMode$ | async as mode">
			<div
				*ngIf="selectedTab.value$ | async as cat"
				class="flex justify-end space-x-1"
			>
				<ng-container *ngIf="cat === 'project'">
					<button
						(click)="this.selectTableDisplayMode(this.tableDisplayTypes.Simple)"
						[class.bg-primary-2]="!displayModeLoading && mode === 'Simple'"
						[disabled]="displayModeLoading"
						[matTooltip]="'utils.tableDisplayMode.simple' | translate"
						[send-tagmanager_event]="{
              category: 'feature',
              action: 'button tableDisplayMode tableDisplayMode_Simple',
            }"
						class="flex flex-col items-center justify-center"
						color="primary"
						mat-icon-button
					>
						<ng-container
							*ngTemplateOutlet="displayModeLoading === 'Simple' ? btnLoading : simpleIcon"
						></ng-container>
					</button>
					<button
						(click)="this.selectTableDisplayMode(this.tableDisplayTypes.Grouped)"
						[class.bg-primary-2]="!displayModeLoading && mode === 'Grouped'"
						[disabled]="displayModeLoading"
						[matTooltip]="'utils.tableDisplayMode.grouped' | translate"
						[send-tagmanager_event]="{
              category: 'feature',
              action: 'button tableDisplayMode tableDisplayMode_Grouped',
            }"
						class="flex flex-col items-center justify-center"
						color="primary"
						mat-icon-button
					>
						<ng-container
							*ngTemplateOutlet="displayModeLoading === 'Grouped' ? btnLoading : groupedIcon"
						></ng-container>
					</button>
					<button
						(click)="this.selectTableDisplayMode(this.tableDisplayTypes.Calendar)"
						[class.bg-primary-2]="!displayModeLoading && mode === 'Calendar'"
						[disabled]="displayModeLoading"
						[matTooltip]="'utils.tableDisplayMode.calendar' | translate"
						[send-tagmanager_event]="{
              category: 'feature',
              action: 'button tableDisplayMode tableDisplayMode_Calendar',
            }"
						*ngIf="!(this.isMobileCalendar$ | async)"
						class="flex flex-col items-center justify-center"
						color="primary"
						mat-icon-button
					>
						<ng-container
							*ngTemplateOutlet="displayModeLoading === 'Calendar' ? btnLoading : calendarIcon"
						></ng-container>
					</button>
				</ng-container>
				<ng-container *ngIf="cat === 'work'">
					<button
						(click)="this.selectTableDisplayMode(this.tableDisplayTypes.ComeGo)"
						[class.bg-primary-2]="!displayModeLoading && mode === 'ComeGo'"
						[disabled]="displayModeLoading"
						[matTooltip]="'utils.tableDisplayMode.comego' | translate"
						[send-tagmanager_event]="{
              category: 'feature',
              action: 'button tableDisplayMode tableDisplayMode_Comego',
            }"
						class="flex flex-col items-center justify-center !rounded-full"
						color="primary"
						mat-icon-button
					>
						<ng-container
							*ngTemplateOutlet="displayModeLoading === 'ComeGo' ? btnLoading : comegoIcon"
						></ng-container>
					</button>
				</ng-container>
			</div>
		</ng-container>
	</ng-template>
	<div class="flex flex-col space-y-2">
		<ng-container *ngIf="projecthoursEnabled$.value$ | async">
			<div class=" flex flex-row space-x-2">
				@if(!(comegoEnabled$ | async) && !(scheduleEnabled$| async) ) {
				<div
					*ngIf="sumOfWeek$ | async as item"
					class="cursor-default flex-col flex h-12 items-center justify-end rounded-lg border border-gray-200/80 bg-white px-2 shadow shadow-gray-700/10 dark:border-neutral-800 dark:bg-transparent dark:shadow-none"
				>
					<small [matTooltip]=" 'time.plural'| translate ">
						<strong> {{ item?.total ?? 0 | parseMsAsDuration: false }}</strong>
					</small>
					<small
						[matTooltip]=" 'Billable'| translate "
						class="mat-hint mat-text-accent"
					>
						{{ (item.billable ? item.billable : 0) | parseMsAsDuration: false }}</small
					>
				</div>
				} @if((workinhoursEnabled$.value$ | async) && (projecthoursEnabled$.value$ | async) ) {
				<div
					*ngIf="selectedTab.value$ | async as cat"
					class="flex h-12 items-center justify-end space-x-2 rounded-lg border border-gray-200/80 bg-white px-2 shadow shadow-gray-700/10 dark:border-neutral-800 dark:bg-transparent dark:shadow-none"
				>
					<div class="relative">
						<button
							(click)="tabChange('project')"
							[class.bg-primary-2]="!displayModeLoading && cat === 'project'"
							[disabled]="displayModeLoading"
							[ngClass]="{ '!rounded-md !w-9 !h-9': isMobile$xs | async }"
							[send-tagmanager_event]="{
				category: 'feature',
				action: 'button tableDisplayMode tableDisplayMode_Simple',
				}"
							class="flex flex-col items-center justify-center !rounded-lg"
							color="primary"
							mat-button
						>
							@if (isMobile$xs | async) {<mat-icon>view_timeline</mat-icon>} @else {
							{{ 'times.projectTab' | translate }}}
						</button>
					</div>
					<ng-container>
						<div class="relative">
							<button
								(click)="tabChange('work')"
								[class.bg-primary-2]="!displayModeLoading && cat === 'work'"
								[disabled]="displayModeLoading"
								[ngClass]="{ '!rounded-md !w-9 !h-9': isMobile$xs | async }"
								[send-tagmanager_event]="{
					category: 'feature',
					action: 'button tableDisplayMode tableDisplayMode_Simple',
				}"
								class="flex flex-col items-center justify-center !rounded-lg"
								color="primary"
								mat-button
							>
								@if (isMobile$xs | async) {<mat-icon>work_history</mat-icon>} @else {
								{{ 'times.workTab' | translate }}}
							</button>
						</div>
					</ng-container>
				</div>
				} @else {
				<div class="flex flex-row space-x-2 items-center justify-center">
					<ng-container *ngTemplateOutlet="viewToggleContent"></ng-container>
				</div>
				}
			</div>
			@if((workinhoursEnabled$.value$ | async) && (projecthoursEnabled$.value$ | async) ) {
			<ng-container *ngTemplateOutlet="viewToggleContent"></ng-container>
			}
		</ng-container>
	</div>
	<ng-template #simpleIcon> <mat-icon>list</mat-icon> </ng-template>
	<ng-template #groupedIcon> <mat-icon>view_stream</mat-icon> </ng-template>
	<ng-template #calendarIcon> <mat-icon>event</mat-icon> </ng-template>
	<ng-template #comegoIcon> <mat-icon>list</mat-icon> </ng-template>
	<ng-template #btnLoading>
		<span class="btn-loading-spinner-wrapper">
			<mat-spinner
				[diameter]="18"
				color="primary"
				mode="indeterminate"
			></mat-spinner>
		</span>
	</ng-template>
</ng-template>
<ng-template #autoModeGhosts>
	<div class="time-entries-wrapper flex flex-col">
		<div class="d-none flex flex-row items-center">
			<div class="justfiy-items-center align-items-start flex flex-grow flex-col">
				<div
					(click)="this.focusElementById('record_toolbar_name')"
					class="help-container cursor-pointer"
				>
					<mat-icon
						class="help-icon"
						inline
						svgIcon="record_help_1"
					></mat-icon>
					<span>{{ 'record-toolbar.help.step-timer-1' | translate }}</span>
				</div>
			</div>
			<div
				class="justfiy-items-center align-items-start flex flex-col"
				style="width: 240px"
			>
				<div
					(click)="this.clickElementById('record_toolbar_project')"
					class="help-container cursor-pointer"
				>
					<mat-icon
						class="help-icon"
						inline
						svgIcon="record_help_2"
					></mat-icon>
					<span>{{ 'record-toolbar.help.step-timer-2' | translate }}</span>
				</div>
			</div>
			<div
				class="justfiy-items-center align-items-start flex flex-col"
				style="width: 160px"
			>
				<div
					(click)="this.clickElementById('record_toolbar_timer_submit')"
					class="help-container cursor-pointer"
				>
					<mat-icon
						class="help-icon"
						inline
						svgIcon="record_help_timer_3"
					></mat-icon>
					<span>{{ 'record-toolbar.help.step-timer-3' | translate }}</span>
				</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #manualModeGhost>
	<div class="time-entries-wrapper flex flex-col">
		<div class="d-none flex flex-row items-center">
			<div class="justfiy-items-center align-items-start flex flex-grow flex-col">
				<div
					(click)="this.focusElementById('record_toolbar_name')"
					class="help-container cursor-pointer"
				>
					<mat-icon
						class="help-icon"
						inline
						svgIcon="record_help_1"
					></mat-icon>
					<span>{{ 'record-toolbar.help.step-1' | translate }}</span>
				</div>
			</div>
			<div
				class="justfiy-items-center align-items-start flex flex-col"
				style="width: 290px"
			>
				<div
					(click)="this.clickElementById('record_toolbar_project')"
					class="help-container cursor-pointer"
				>
					<mat-icon
						class="help-icon"
						inline
						svgIcon="record_help_2"
					></mat-icon>
					<span>{{ 'record-toolbar.help.step-2' | translate }}</span>
				</div>
			</div>
			<div
				class="justfiy-items-center align-items-start flex flex-col"
				style="width: 288px"
			>
				<div
					(click)="this.clickElementById('record_toolbar_start')"
					class="help-container cursor-pointer"
				>
					<mat-icon
						class="help-icon"
						inline
						svgIcon="record_help_3"
					></mat-icon>
					<span>{{ 'record-toolbar.help.step-3' | translate }}</span>
				</div>
			</div>
			<div
				class="justfiy-items-center align-items-start flex flex-col"
				style="width: 60"
			>
				<div
					(click)="this.clickElementById('record_toolbar_submit')"
					class="help-container cursor-pointer"
				>
					<mat-icon
						class="help-icon"
						inline
						svgIcon="record_help_4"
					></mat-icon>
					<span>{{ 'record-toolbar.help.step-4' | translate }}</span>
				</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #widgetLoadingRef>
	<mat-progress-spinner
		[diameter]="18"
		[strokeWidth]="2"
		class="mat-white"
		mode="indeterminate"
	></mat-progress-spinner>
</ng-template>
<tg-day-picker-popover
	(viewDateChange)="range.update($event)"
	[max]="maxRangeStart"
	[min]="minRangeStart"
	[viewDate]="range.value$ | async"
	#dayPickerPopover
	rangeType="week"
></tg-day-picker-popover>
<ng-template
	#appRow
	let-content="content"
	let-label="label"
>
	<div
		class="flex h-12 items-center space-x-4 rounded-lg border border-gray-200/80 bg-white px-4 shadow shadow-gray-700/10 dark:border-neutral-800 dark:bg-transparent dark:shadow-none"
	>
		<h1 class="text-muted text-sm">{{ label }}</h1>
		<div class="flex items-center space-x-2"><ng-container *ngTemplateOutlet="content"></ng-container></div>
	</div>
</ng-template>
<ng-template #appListContent>
	<div class="-mr-3 flex space-x-1.5">
		<button
			[matTooltip]="'feed.name' | translate"
			[routerLink]="'/feed'"
			[send-tagmanager_event]="{
        category: 'feature',
        action: 'button timerShortcut timerShortcut_feed',
      }"
			class="mat-button-square !rounded-lg"
			mat-button
		>
			<mat-icon
				class="route-icon-calendar"
				svgIcon="fcalendar"
			></mat-icon>
		</button>
		<button
			[matTooltip]="'reports.detailed' | translate"
			[queryParams]="{
        start: vd.start.toISOString(),
        end: vd.end.toISOString(),
      }"
			[routerLink]="'/dashboard/detailed'"
			[send-tagmanager_event]="{
        category: 'feature',
        action: 'button timerShortcut timerShortcut_dashboard',
      }"
			*ngIf="viewDate$ | async as vd"
			class="mat-button-square !rounded-lg"
			mat-button
		>
			<mat-icon
				class="route-icon-dashboard"
				svgIcon="fdashboard"
			></mat-icon>
		</button>
	</div>
</ng-template>
<ng-template
	#scheduleWeekView
	let-isProjectTab="isProjectTab"
	let-sched
>
	<div
		[matTooltipDisabled]="isProjectTab"
		[matTooltipTemplate]="scheduleTooltip"
		[matTooltipTemplateContext]="{ $implicit: sched }"
		[ngClass]="{ 'grid-cols-[1fr_28px]': true }"
		class="mat-bd-5 mat-typography grid h-12 items-center gap-x-6 rounded-lg px-4"
		matTooltip
	>
		<div
			[ngClass]="{ 'text-sm': !isProjectTab }"
			class="flex flex-col text-right"
		>
			<span>{{ sched.used | parseMsAsDuration }}</span>
			@if(!isProjectTab) {
			<span>{{ sched.max | parseMsAsDuration }}</span>
			}
		</div>
		@if(!isProjectTab) {
		<div class="mat-circle-card">
			<mat-progress-spinner
				[color]="sched.graphState"
				[diameter]="20"
				[value]="sched.percent * 100 | clamp: 0 : 100"
				class="with-back-spinner"
				strokeWidth="3"
			></mat-progress-spinner>
		</div>
		}
	</div>
</ng-template>
<ng-template
	#scheduleTooltip
	let-sched
>
	<div class="mat-typography flex flex-col px-3 py-2.5">
		<div class="flex items-center space-x-2">
			<span>{{ sched.name || ('schedules.name' | translate) }}</span>
			<ng-container *ngIf="sched.percent >= 0">
				<span class="dot size-1.5"></span>
				<span>{{ sched.percent | percent }}</span>
			</ng-container>
		</div>
	</div>
</ng-template>
